export default __webpack_public_path__ + "static/media/ChatGroup.4b5a47ea.svg";